<div class="flex flex-col gap-4 pb-5 h-full md:pb-30">
  @for (banner of banners$ | async; track $index) {
    <app-card class="h-[calc(var(--vh)-20rem)] md:h-[35rem] sticky top-5">
      <div app-card-content class="p-3! pb-6! h-full">
        @if (banner.url) {
          <a class="group flex h-full overflow-hidden rounded-xl" [href]="banner.url" [target]="banner.target">
            <img
              class="w-full group-hover:scale-110 duration-300 transition group-active:brightness-110 rounded-xl h-full object-cover"
              loading="lazy"
              [src]="banner.imagem_app"
              [alt]="banner.titulo"
            />
          </a>
        } @else {
          <img
            class="w-full rounded-xl h-full object-cover"
            loading="lazy"
            [src]="banner.imagem_app"
            [alt]="banner.titulo"
          />
        }
      </div>
    </app-card>
  } @empty {
    @if (loading()) {
      <div class="flex gap-4 w-full animate-pulse">
        <app-skeleton class="h-48! rounded-xl"></app-skeleton>
      </div>
    } @else {
      <app-jumbotron translate> geral.nenhum-dado </app-jumbotron>
    }
  }
</div>
